import { faCss3, faFigma, faHtml5, faJs, faReact, faSass } from "@fortawesome/free-brands-svg-icons";

const projectsData = [
    {
      id: 1,
      title: "Oh My Food",
      githublink: "https://github.com/MatthieuGrauleau/Ohmyfood",
      websitelink: "https://ohmyfood-mg.netlify.app",
      image: "/assets/images/ohmyfood.png",
      description: "Ce projet met l'accent sur la découverte et la mise en place d’animations CSS, ainsi que sur la création de plusieurs pages. J'ai notamment intégré un écran de chargement et des animations d'escaliers lors de l’apparition des menus.",
      skills: [ faHtml5, faCss3],
    },
    {
      id: 2,
      title: "Bubble Game Shooter",
      githublink: "https://github.com/MatthieuGrauleau/BubbleGameShooter",
      websitelink:"https://bubble-game-shooter.netlify.app",
      image: "/assets/images/bubble.png",
      description: "Ce projet m'a permis de m'entrainer à l'utilisation de JavaScript afin de créer un petit jeu et un compteur de score.",
      skills: [ faHtml5, faCss3, faJs],
    },
    {
      id: 3,
        title: "Print-it",
        githublink: "https://github.com/MatthieuGrauleau/Print-it",
        websitelink:"https://print-it-mg.netlify.app",
        image: "/assets/images/printit.png",
        description: "Dans ce projet de développement front-end, ma mission consistait à concevoir un carrousel interactif en JavaScript pour le site web de l'imprimerie Print It. Mon objectif principal était de fournir aux visiteurs une expérience de navigation fluide à travers les images. Pour ce faire, j'ai mis en place des fonctionnalités telles que des flèches pour la navigation, des indicateurs pour suivre la position actuelle, tout en assurant un défilement en boucle, offrant ainsi une expérience intuitive et agréable.",
        skills: [ faHtml5, faCss3, faJs],
      },
      {
        id: 4,
        title: "Sophie Bluel",
        githublink: "https://github.com/MatthieuGrauleau/Sophie-Bluel",
        websitelink:"",
        image: "/assets/images/sophiebluel.png",
        description: "Dans ce projet, j'ai été responsable de la création d'un site web dynamique et du développement de multiples fonctionnalités pour le portfolio d'une architecte d'intérieur. Cela englobait la conception de la page de présentation des travaux de l'architecte, la configuration de la page de connexion pour l'administrateur du site, et la mise en place d'une modale permettant d'uploader de nouveaux médias. J'ai utilisé le code back-end existant pour établir des requêtes vers l'API, permettant ainsi la récupération des données des différents projets.",
       skills: [ faHtml5, faCss3, faJs, faFigma],
      },
      {
        id: 5,
        title: "Kasa",
        githublink: "https://github.com/MatthieuGrauleau/Kasa",
        websitelink:"https://kasa-mg.netlify.app",
        image: "/assets/images/kasa.png",
        description: "Mon rôle principal impliquait le développement complet de l'application front-end en utilisant React. Cela incluait le suivi des maquettes Figma et la responsabilité de maintenir une qualité optimale du code.",
       skills: [ faHtml5, faSass, faReact, faFigma],
      },
      {
        id: 6,
        title: "Nina Carducci",
        githublink: "https://github.com/MatthieuGrauleau/NinaCarducci",
        websitelink:"",
        image: "/assets/images/ninacarducci.png",
        description: "Le site rencontrait des problèmes de vitesse de chargement et de visibilité en ligne. J'ai travaillé à améliorer le référencement SEO, les performances du site, ainsi que son accessibilité. Cela a impliqué l'optimisation du poids des images, l'ajout de balises pour les réseaux sociaux, et le renforcement du référencement local pour élargir la portée. J'ai employé des outils tels que Lighthouse et Wave pour évaluer et améliorer les performances du site. Notre collaboration a permis de résoudre ces problèmes et d'accroître la visibilité en ligne de Nina.",
        skills: [ faHtml5, faCss3],
      },
      {
        id: 7,
        title: "724 Events",
        githublink: "https://github.com/MatthieuGrauleau/724events",
        websitelink:"https://724events-mg.netlify.app",
        image: "/assets/images/724events.png",
        description: "Ma tâche impliquait la résolution des problèmes et le test du site web de l'agence événementielle 724events. Le site, partiellement intégré par un développeur précédent, présentait des défauts impactant l'expérience des visiteurs. J'ai utilisé divers outils de développement, incluant notamment React Developer Tools, pour scruter le comportement du site. En suivant les indications de l'ancien développeur et en complétant le cahier de recette, j'ai pu identifier et rectifier les problèmes détectés.",
        skills: [ faHtml5, faCss3, faReact],
      },
      {
        id: 8,
        title: "Argent Bank",
        githublink: "https://github.com/MatthieuGrauleau/ArgentBank",
        websitelink:"",
        image: "/assets/images/argentbank.png",
        description: "J'ai conçu la partie front-end d'une application web en utilisant React. J'ai intégré Redux pour gérer l'état de l'application. Cette application offre aux utilisateurs la possibilité d'accéder à la page d'accueil, de se connecter, de consulter leur profil et de se déconnecter. J'ai appliqué des bonnes pratiques Green Code pour optimiser les images et créer des composants réutilisables. En plus, j'ai élaboré une documentation Swagger pour faciliter la gestion des transactions futures.",
       skills: [ faHtml5, faSass, faReact],
      },
  ];
  
  export default projectsData;
  